import 'slick-carousel/slick/slick.css';
import './src/styles/tailwind.scss';
import './src/styles/global.scss';
